// extracted by mini-css-extract-plugin
export var headingImage = "post-module--headingImage--2XzNX";
export var main = "post-module--main--1O0Km";
export var titleSection = "post-module--titleSection--C_3pQ";
export var text = "post-module--text--3pKUp";
export var references = "post-module--references--1TTkh";
export var postInfo = "post-module--postInfo--2Ds5D";
export var imageContainer = "post-module--imageContainer--USl9M";
export var imageDescription = "post-module--imageDescription--2JcNy";
export var imageWrapper = "post-module--imageWrapper--2Dw9J";